export interface StyleConfig {
  [key: string]: string;
}

export interface CitationStyles {
  [key: string]: StyleConfig;
}

export const styles: CitationStyles = {
  "apa": {
    "american": "apa",
  },
  "iso-classic": {
    "french": "sorbonne-student-law-review"
  },
  "iso-classic-2021": {
    "french": "sorbonne-student-law-review"
  },
  "mla8": {
    "american": "modern-language-association",
  },
  "chicago": {
    "american": "chicago-author-date",
    "french": "chicago-fullnote-bibliography-with-ibid",
  },
  "harvard": {
    "american": "harvard-cite-them-right",
  },
  "vancouver": {
    "american": "vancouver-author-date",
  },
};